import { TYPES } from '../render/constants';
import { Action } from './action';

function condition() {
  return true;
}

function enterClipMode(stageContext) {
  const nodes = stageContext.api.getSelectedNodes();
  const node = nodes[0];
  if (!node || node.type !== TYPES.image) return;
  const { interactive } = stageContext.providers;
  interactive.enterClipMode(node);
}

export const imageClippingModeAction = new Action({
  name: 'ImageCrop',
  handler: enterClipMode,
  condition: condition,
});
